
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diy/[...blogPath]",
      function () {
        return require("private-next-pages/diy/[...blogPath].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diy/[...blogPath]"])
      });
    }
  